import { createApi } from '@reduxjs/toolkit/query/react';
import { Color } from 'antd/es/color-picker';
import { baseUrlWithCustomHeader } from '../../../app/auth/apiSlice';

export interface MenuProps {
  count: number;
  next?: null;
  previous?: null;
  results: MenuItemProps[];
}
export interface SubMenuProps {
  count: number;
  next?: null;
  previous?: null;
  results: SubMenuItemProps[];
}
export interface MenuItemProps {
  action: string;
  color: string | Color;
  icon_name: string;
  id: number | string | undefined;
  is_active?: boolean;
  menu: number | string;
  order: number | string;
  title_bn?: string;
  title_en: string;
  url?: string;
  sub_menu_items?: SubMenuItemProps[];
}
export interface SubMenuItemProps {
  id?: number | string;
  menu_item?: string | number;
  order: number | string;
  icon_name: string;
  title_bn?: string;
  title_en: string;
  has_cap?: boolean;
  keywords?: string;
  url?: string;
  is_active?: boolean;
  is_popular?: boolean;
}

export const cashApi = createApi({
  reducerPath: 'cashApi',
  baseQuery: baseUrlWithCustomHeader,
  // tagTypes: ['SideNavMenu', 'FavoritesMenu'],
  endpoints: (__builder) => ({
    // menus
    // getSideNavMenus: builder.query<MenuProps, void>({
    //   query: () => {
    //     return `v1/web-contents/menus/1/?limit=1000&offset=0`;
    //   },
    //   providesTags: ['SideNavMenu'],
    // }),
    // getSideNavFavoritesMenus: builder.query<FavoriteMenuItemsProps, void>({
    //   query: () => {
    //     return `v1/web-contents/favorites/`;
    //   },
    //   providesTags: ['FavoritesMenu'],
    // }),
    // addFavoriteList: builder.mutation({
    //   query: (arg: {
    //     submenu_item: string | number;
    //     user: string | number;
    //   }) => ({
    //     url: `v1/web-contents/favorites/`,
    //     method: 'POST',
    //     body: arg,
    //   }),
    //   invalidatesTags: ['FavoritesMenu', 'SideNavMenu'],
    // }),
    // deleteFavoriteList: builder.mutation({
    //   query: (id) => ({
    //     url: `v1/web-contents/favorites/submenu-item/${id}/`,
    //     method: 'DELETE',
    //   }),
    //   invalidatesTags: ['FavoritesMenu', 'SideNavMenu'],
    // }),
  }),
});

// export const {
//   useGetSideNavMenusQuery,
//   useGetSideNavFavoritesMenusQuery,
//   useAddFavoriteListMutation,
//   useDeleteFavoriteListMutation,
// } = cashApi;
